import React from 'react';
import { createRoot } from 'react-dom/client';
import './style.css';
import App from './App';
import ReloadPrompt from './components/ReloadPrompt';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
    <ReloadPrompt />
  </React.StrictMode>
);

reportWebVitals();
